const domainToLocale = {
  com: 'en-GB',
  se: 'sv-SE',
  no: 'nb-NO',
  dk: 'da-DK',
  fi: 'fi-FI',
  de: 'de-DE',
  fr: 'fr-FR',
  es: 'es-ES',
  it: 'it-IT',
};

const domainRegex = /\.+([a-z]{2,}).*/;

function getLocaleFromUrl(urlString) {
  if (!urlString) {
    return null;
  }

  try {
    const url = new URL(urlString);
    const domainParts = url.host.split('.');
    const locale = domainToLocale[domainParts[domainParts.length - 1]];
    if (locale) {
      return locale;
    }
  } catch (e) {
    const domainMatch = urlString.match(domainRegex);
    if (domainMatch) {
      return domainToLocale[domainMatch[1]];
    }
  }
  return null;
}

module.exports = {
  getLocaleFromUrl,
};
